import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const Sidebar = styled.div`
  width: 450px;

  @media (max-width: 767px) {
    width: 100%;
    height: calc(var(--full-vh, 1vh) * 100 - var(--header-height));
    position: relative;
  }

  @media (max-height: 500px) {
    width: 100%;
    height: calc(var(--full-vh, 1vh) * 100 - var(--header-height));
    position: relative;
  }
`;

export const Map = styled.div`
  position: relative;
  width: calc(100% - 450px);

  @media (max-width: 767px) {
    width: 100%;
    height: calc(var(--full-vh, 1vh) * 100 - 67px);
    position: absolute;
  }

  @media (max-height: 500px) {
    width: 100%;
    height: calc(var(--full-vh, 1vh) * 100 - 67px);
    position: absolute;
  }
`;
